import { render } from "./NcrmCompanyEmailSendDialog.vue?vue&type=template&id=428f1473&scoped=true"
import script from "./NcrmCompanyEmailSendDialog.vue?vue&type=script&lang=js"
export * from "./NcrmCompanyEmailSendDialog.vue?vue&type=script&lang=js"

import "./NcrmCompanyEmailSendDialog.vue?vue&type=style&index=0&id=428f1473&lang=css"
import "./NcrmCompanyEmailSendDialog.vue?vue&type=style&index=1&id=428f1473&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-428f1473"]])

export default __exports__